import { render, staticRenderFns } from "./BikyConfigChatCorrectPronunciation.vue?vue&type=template&id=39fbc57a&scoped=true&"
import script from "./BikyConfigChatCorrectPronunciation.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigChatCorrectPronunciation.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigChatCorrectPronunciation.vue?vue&type=style&index=0&id=39fbc57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fbc57a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
